import React from 'react'
import styled from 'styled-components'
import { colors as oldColors } from 'shared/assets/styles'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { type RootState } from 'shared/store/reducers'
import { CaptionText, H5 } from 'app/common/typography'
import { CircleChevron, Ticket } from 'app/assets/icons'
import { SPACING } from 'app-v2/design-tokens'
import { useWindowSize } from 'hooks/useWindowSize'
import { media } from 'app/assets/styles'

const { orange2 } = oldColors

type Props = {
    onClick?: () => void
}

const MAX_MOB_SCREEN_W = 2 * 27 + 500

export const ImpersonalOperationCard = ({ onClick }: Props) => {
    const intl = useIntl()
    const { couponInsertWeb } = useSelector(
        (state: RootState) => state.applicationState
    )
    const { width } = useWindowSize()
    if (couponInsertWeb) {
        const {
            backgroundImageWebMob,
            backgroundImageWebDesk
        } = couponInsertWeb
        if (backgroundImageWebMob && width <= MAX_MOB_SCREEN_W) {
            return (
                <StyledImageContainer onClick={onClick}>
                    <StyledImageMob alt="" src={backgroundImageWebMob} />
                </StyledImageContainer>
            )
        }
        if (backgroundImageWebDesk && width > MAX_MOB_SCREEN_W) {
            return (
                <StyledImageContainer onClick={onClick}>
                    <StyledImageDesk alt="" src={backgroundImageWebDesk} />
                </StyledImageContainer>
            )
        }
    }
    return (
        <Container onClick={onClick}>
            <ImageContainer>
                <Ticket color="white" size={40} />
            </ImageContainer>
            <TextContainer height="45">
                <H5 color="white" center>
                    {intl.formatMessage({
                        id: 'operation.impersonal.card.promo.title'
                    })}
                </H5>
                <CaptionText color="white" center>
                    {intl.formatMessage({
                        id: 'operation.impersonal.card.promo.subtitle'
                    })}
                </CaptionText>
            </TextContainer>
            <ChevronContainer>
                <CircleChevron color="white" background="none" size={50} />
            </ChevronContainer>
        </Container>
    )
}

const StyledImageContainer = styled.div`
    ${props => props.onClick && 'cursor: pointer;'}
    width: 100%;
    margin-top: ${SPACING.XS};
    display: flex;
    justify-content: center;
`

const StyledImageMob = styled.img`
    width: 100%;
    height: 65px;
    object-fit: cover;
    border-radius: ${SPACING.XXS};
`

const StyledImageDesk = styled.img`
    width: 100%;
    height: 65px;
    ${media.small`height: 75px;`}
    ${media.medium`height: 85px;`}
    ${media.large`height: 95px;`}
    object-fit: cover;
    border-radius: ${SPACING.XXS};
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: ${orange2};
    margin-top: ${SPACING.XS};
    padding: ${SPACING.XXXS};
    ${props => props.onClick && 'cursor: pointer;'}
`

const ImageContainer = styled.div`
    margin-right: 15px;
`

const ChevronContainer = styled.div`
    margin-left: 15px;
`
